import * as React from 'react';
import styled from 'styled-components';
import { Styledes, Childable } from './types';

export interface Props extends Styledes, Childable {}

const Title = styled.div`
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 1em;
    padding-top: 1em;
    padding-bottom: 1em;
`;

export default React.memo(({ children, className }: Props) => {
    return (
        <Title className={className}>{children}</Title>
    );
});
